var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",class:{
    'full-width': _vm.disableMinWidth,
    fullscreen: _vm.isFullscreen,
    'is-vacancy': _vm.isVacancy,
    'is-adaptive': _vm.is_adaptive,
    'header-not-fixed': _vm.fixedHeader,
    'public-response': _vm.public_response,
    grid: _vm.is_grid
  },attrs:{"id":"main-inner"}},[_c('router-view',{attrs:{"name":"rates_informer"}}),_vm._v(" "),_c('router-view',{class:{ is_admin: _vm.is_admin },attrs:{"name":"header"}}),_vm._v(" "),_c('div',{staticClass:"content-wrapper",class:{
      'header-not-fixed': _vm.fixedHeader,
      'custom-input-fields': _vm.customInputFields,
      'min-width': !_vm.videointerviewStartOrEndPage && !_vm.disableMinWidth,
      is_admin: _vm.is_admin,
      'online-interview': _vm.online_interview
    }},[_c('router-view',{attrs:{"name":"header_form"}}),_vm._v(" "),_c('router-view',{staticClass:"content",class:{ grid: _vm.is_grid, 'full-width': _vm.disableMinWidth }})],1),_vm._v(" "),_c('router-view',{attrs:{"name":"footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }